<template>
  <section class="grid-flex column">
    <div>
      <h3>Editar Funil</h3>
    </div>
    <section class="box flex-1 w100 margin-top-s">
      <div class="box-content">
        <div class="item ">
          <label>Nome:</label>
          <input class="input margin-top-s" v-model="newFunnel.name">
        </div>
      </div>
    </section>
    <div class="margin-top-l">
      <h3>Etapas do Funil</h3>
    </div>
    <section class="box flex column w100 margin-top-s">

      <div class="box-content list-itens flex column w100">
        <div> 
          <div class="button primary" @click="openModalCreate()">
            Criar nova Etapa
          </div>
        </div>
        <div
          class="box flex-1 w100 step-item"
          v-for="(fs, index) in funnelSteps"
          :key="index"
        >
        <div class="box-content">
          <div class="flex-1 w100">
            <div class="flex middle row">
              <div class="flex-3">
                <div class="flex middle row">
                  <div class="flex-1 name">
                    <div>
                      Nome: {{ fs.name }}
                    </div>
                    <div class="margin-top-s">
                      Regra(s): {{ fs.rule_fields && fs.rule_fields.length | number }}
                    </div>
                  </div>
                  
                </div>
              </div>
              <div class="action">
                <div class="flex end">
                  <div class="button primary" @click="openToEdit(fs)">
                    EDITAR
                  </div>
                  <div
                    class="button primary"
                    @click="openToDelete(fs.id)"
                    style="margin-left: 8px"
                  >
                    DELETAR
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
      <div v-if="isEmpty" class="box flex w100">
        <div class="box-content">
          <p>
            Não encontramos nenhum etapa do funil criado. Crie seu primeiro etapa do funil para ter
            seus rastreamentos.
          </p>
        </div>
      </div>

      <div v-if="loading" class="flex w100">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </section>

    <section class="flex w100 margin-top-l">
      <div class="button secondary" style="margin-right: 8px;" @click="$router.back()">Voltar</div>
      <div class="button primary"  @click="updateFunnel()">Salvar</div>
    </section>

    <!-- modal create / edit -->
    <modal
      :title="titleModal"
      :show="showModalCreateOrUpdate"
      largebox="true"
      @close="closeToEdit()"
    >
      <div class="content flex " slot="content">
        <div class="flex column w100">
          <form autocomplete="off" class="w100">
            <div class="flex-1 w100">
              <label>Nome</label>
              <input
                class="input"
                id="name"
                type="text"
                v-model="newFunnelStep.name"
                autocomplete="off"
              />
            </div>
            <div class="flex-1 w100 margin-top-s">
              <label>Order</label>
              <input
                class="input"
                id="order"
                type="number"
                v-model="newFunnelStep.order"
                autocomplete="off"
              />
            </div>
            <div class="flex-1 w100 margin-top-s">
              Regras de público
              <div class="margin-top-s">
                <logical-expression-builder 
                  :initialOptions="[]"
                  :initialConditions="newFunnelStep.rule_fields"
                  @save="newFunnelStep.rule_fields = $event"
                />
              </div>
            </div>
          </form>
          <div class="flex w100 center margin-top-l">
            <div class="button primary" @click="saveOrupdateFunnelStep()">
              {{isEdit ? 'SALVAR': 'CRIAR'}}
            </div>
          </div>
        </div>
      </div>
    </modal>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar essa Etapa do Funil?"
      @cancel="
        showModalDelete = false;
        selectedStepId = null;
      "
      @accept="deleteFunnelStep(selectedStepId)"
    ></modal-confirm>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");
import { mapState } from "vuex";
import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";
import LogicalExpressionBuilder from "@/components/logical/LogicalExpressionBuilder";

import {
  getFunnel,
  updateFunnel,
  deleteFunnel,
  getFunnelSteps,
  createFunnelStep,
  updateFunnelStep,
  deleteFunnelStep
} from "@/services/funnel";

const EMPTY_FUNNEL_STEP = {
  name: "",
  order : 1,
  rule_fields: []
};

export default {
  name: "funnel",
  components: {
    Modal,
    ModalConfirm,
    LogicalExpressionBuilder,
  },
  props: ['funnel_id'],
  data() {
    return {
      loading: false,
      loadingReport: false,
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      selectedStepId: null,
      newFunnelStep: Object.assign({}, EMPTY_FUNNEL_STEP),
      funnelSteps: [],
      newFunnel: {},
    };
  },
  mounted() {
    this.getFunnel();
    this.getFunnelSteps();
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.funnelSteps = [];
        this.reportfunnelSteps = {};
        this.getFunnelSteps();
      },
    },
    page: {
      handler() {
        this.funnelSteps = [];
        this.getFunnelSteps();
      },
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    titleModal() {
      return this.isEdit ? 'Editar Etapa': 'Criar Etapa'
    },
    isEmpty() {
      return this.totalfunnelSteps === 0 && !this.loading;
    },
    isEdit() {
      if (this.newFunnelStep && this.newFunnelStep.id) {
        return true
      }
      return false
    },
    totalPages() {
      let valueMode = this.totalfunnelSteps % this.offset;
      let value = this.totalfunnelSteps / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
    alertLimit() {
      if (this.account && this.account.plan_limits.limit_shortlink <= this.account.used_limits.limit_shortlink) {
        return true
      }

      return false
    },
  },
  methods: {
    getClicks(shId) {
      if (!this.reportfunnelSteps[shId]) {
        return '-'
      }

      return this.reportfunnelSteps[shId][ 'clicks']
    },
    openModalCreate() {
      if(this.alertLimit) {
        this.$toast.error({
          title:'Erro',
          message:'Você já está usando o limite de links rastreaveis do seu plano! Faça upgrade para criar mais!'
        })

        return

      }
      
      this.showModalCreateOrUpdate = true
    },
    openToDelete(sl) {
      this.showModalDelete = true;
      this.selectedStepId = sl;
    },
    openToEdit(sl) {
      this.showModalCreateOrUpdate = true;
      this.newFunnelStep = sl;
    },
    closeToEdit() {
      this.showModalCreateOrUpdate = false;
      this.newFunnelStep = Object.assign({}, EMPTY_FUNNEL_STEP);
    },
    saveOrupdateFunnelStep() {
      if (this.isEdit) {
        this.updateFunnelStep(this.newFunnelStep.id);
      } else {
        this.createFunnelStep();
      }
      this.closeToEdit();
    },
    getFunnel() {
      this.loading = true;
      getFunnel(this.funnel_id)
        .then((result) => {
          this.newFunnel = result;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    updateFunnel() {
      let params = {
        name: this.newFunnel.name,
      };

      updateFunnel(this.funnel_id, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Funil editado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    deleteFunnel(funnelId) {
      deleteFunnel(funnelId)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Funil deletado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.selectedStepId = null;
          this.showModalDelete = false
        })
    },
    getFunnelSteps() {
      this.loading = true;
      getFunnelSteps(this.funnel_id)
        .then((result) => {
          this.funnelSteps = result.funnel_steps;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createFunnelStep() {
      console.log('this.newFunnelStep', this.newFunnelStep)
      let params = {
        name: this.newFunnelStep.name,
        order: this.newFunnelStep.order,
        rule_fields: this.newFunnelStep.rule_fields
        
      };
      createFunnelStep(this.funnel_id, params)
        .then((result) => {
          this.funnelSteps.push(result);

          this.$toast.success({
            title: "Sucesso",
            message: "Etapa criada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    updateFunnelStep(stepId) {
      console.log('this.newFunnelStep', this.newFunnelStep)
      let params = {
        name: this.newFunnelStep.name,
        order: this.newFunnelStep.order,
        rule_fields: this.newFunnelStep.rule_fields
      };

      updateFunnelStep(this.funnel_id, stepId, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Etapa editada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    deleteFunnelStep(setpId) {
      deleteFunnelStep(this.funnel_id, setpId)
        .then(() => {

          this.funnelSteps = this.funnelSteps.filter(e => e.id !== setpId)
          this.$toast.success({
            title: "Sucesso",
            message: "Etapa deletado com sucesso",
          });


        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.selectedStepId = null;
          this.showModalDelete = false
        })
    },
  },
};

</script>

<style lang="scss" scoped>

.list-itens {
  .box + .box {
    margin-top: 8px;
    margin-left: 0px !important;
  }
}

.name {
  max-width: 400px;
  width: 400px;
  min-width: 400px;
  padding-right: 16px;
}
.step-item {
  border-radius: 8px;
  border: 1px solid #c3c3c3;
  margin-top:8px;
}
</style>
